module.exports = __webpack_public_path__ + "static/geekshub-black-logo-5642947c63c5491f894ff5dcd028f341.png";